<template>
    <transition name="slide-fade">
        <vue-draggable-resizable
            v-if              = "visible"
            :w                = "width"
            :h                = "height"
            :y                = "y"
            :x                = "x"
            :resizable        = "false"
            @dragging         = "onDrag"
            :parent           = "true"
            :handles          = "['br']"
            :drag-handle      = "'.drag-handle'"
            class             = "draggable-panel"
            class-name-handle = "draggable-handle-class"
        >
                <div class="drag-handle  v-flex" style="background: #323639">
                    <!--
                    <div>
                        {{ title }}
                    </div>
                    -->
                    <v-spacer />
                    <div style="margin-top: 15px;">
                        <c-toolbar-button
                            icon     = "mdi-close"
                            color    = "white"
                            size     = "24"
                            class    = "mr-2"
                            :tooltip = "$t('common.close')"
                            @click   = "onClose"
                        />
                    </div>
                </div>
                <div class="drag-content" :class="border ? 'drag-content-border-on' : 'drag-content-border-off'">
                    <slot name = "content" />
                </div>
        </vue-draggable-resizable>
    </transition>
</template>

<script>

import VueDraggableResizable from 'vue-draggable-resizable'
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "DResizableDialog",

    components: {
        CToolbarButton,
        VueDraggableResizable
    },

    props: {
        title: {

        },

        value: {

        },

        position: {
            required: true,
            type    : Object,
        },

        size: {
            required: true,
            type    : Object,
        },

        border: {
            required: false,
            type    : Boolean,
            default : () => {
                return true;
            }
        }
    },

    data: () => ({
        visible: false,
        width  : 0,
        height : 0,
        x      : 0,
        y      : 0
    }),

    mounted() {
        this.visible = this.value;
    },

    watch: {
        value () {
            if (this.value) {
                this.reset();
            }

            this.visible = this.value;
        }
    },

    methods: {
        onClose () {
            this.$emit("input", false);
        },

        onResize: function (x, y, width, height) {
            this.x = x
            this.y = y
            this.width = width
            this.height = height
        },

        onDrag: function (x, y) {
            this.x = x
            this.y = y
        },

        reset () {
            this.y      = this.position.y;
            this.x      = this.position.x;
            this.width  = this.size.width;
            this.height = this.size.height;
        }
    }
}
</script>

<style scoped>

.draggable-panel {
    position: absolute;
    z-index: 100!important;
    border: none!important;
    background: white;
    border-radius: 10px;
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
}

.drag-handle {
    margin-left: 40px;
    width: 100%;
    height: 100px;
    padding-left: 12px;
    font-size: 15px;
    border-radius: 10px;
    /*
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

     */
    /*
    border-style: solid;
    border-width: 1px;
    border-color: lightgray!important;
    border-bottom: none;

     */
}

.drag-content {
    background-color: white;
    border-top-style: none;
    width: 100%;
    height: calc(100% - 0px);
    margin-top: -101px;
    padding: 0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.drag-content-border-on {
    border-color: lightgray!important;
    border-style: solid!important;
    border-top: none!important;
}

.drag-content-border-off {
    border: none!important;
}

::v-deep  .draggable-handle-class {
    position: absolute;
}

::v-deep .draggable-handle-class-br {
    width: 30px;
    height: 30px;
    bottom: -8px;
    right: -8px;
    cursor: se-resize;
    /*
    border-right: 30px solid transparent!important;
    border-top: 30px solid white!important;
    background: lightgrey!important;
    z-index: -1;

     */
}

</style>